import { RouteConfig } from 'vue-router'
// import Layout from '@/layout/index.vue'

// 交易订单一级
const tradeRouter: RouteConfig = {
  path: '/trade-ios',
  component: () => import('@/views/trade/ios/index.vue'),
  redirect: '/trade-ios/vip-board',
  meta: {
    title: 'iOS VIP',
    icon: 'menu-trade'
  },
  children: [
    {
      name: 'VipBoard',
      path: 'vip-board',
      component: () => import('@/views/trade/ios/vip-board.vue'),
      meta: {
        title: 'VIP看板',
        showTitle: false
      }
    },
    {
      name: 'OrderDetails',
      path: 'order-details',
      component: () => import('@/views/trade/trade-vip-info/base-info.vue'),
      meta: {
        title: '订单详情',
        showTitle: false
      }
    },
    {
      name: 'TradeVip',
      path: 'trade-vip',
      component: () => import('@/views/trade/trade-vip/index.vue'),
      meta: {
        title: '订单详情',
        showTitle: false
      }
    },
    {
      name: 'TradeVipEn',
      path: 'trade-vip-en',
      component: () => import('@/views/trade/trade-vip/index-en.vue'),
      meta: {
        title: 'Order details',
        showTitle: false
      }
    },
    {
      name: 'VipPriceSystem',
      path: 'vip-price-system',
      component: () => import('@/views/trade/vip-price-system/index.vue'),
      meta: {
        title: 'VIP价格体系',
        showTitle: true
      }
    },
    {
      name: 'VipDiscountImage',
      path: 'vip-discount-image',
      component: () => import('@/views/trade/vip-discount-image/index.vue'),
      meta: {
        title: '活动配置',
        showTitle: false
      }
    },
    {
      name: 'UserSignature',
      path: 'user-signature',
      component: () => import('@/views/trade/trade-vip-info/base-info.vue'),
      meta: {
        title: '用户签名管理',
        showTitle: false
      }
    },
    {
      name: 'ResignTimes',
      path: 'resign-times',
      component: () => import('@/views/trade/trade-vip-info/resign-times.vue'),
      meta: {
        title: '用户重签管理',
        showTitle: true
      }
    },
    {
      name: 'TradeVipInfo',
      path: 'trade-vip-info',
      component: () => import('@/views/trade/trade-vip-info/index.vue'),
      meta: {
        title: 'VIP基本信息',
        showTitle: false
      },
      redirect: '/trade/trade-vip-info/base-info',
      children: [
        {
          name: 'BaseIno',
          path: 'base-info',
          component: () => import('@/views/trade/trade-vip-info/base-info.vue'),
          meta: {
            title: 'VIP基本信息',
            showTitle: false
          }
        },
        {
          name: 'VipResignTimes',
          path: 'resign-times',
          component: () => import('@/views/trade/trade-vip-info/resign-times.vue'),
          meta: {
            title: 'VIP重签次数',
            showTitle: true
          }
        },
        {
          name: 'ResignRecord',
          path: 'resign-record',
          component: () => import('@/views/trade/trade-vip-info/resign-record.vue'),
          meta: {
            title: 'VIP重签记录',
            showTitle: true
          }
        }
      ]
    }
    // {
    //   name: 'TradeGame',
    //   path: 'trade-game',
    //   component: () => import('@/views/trade/trade-game/index.vue'),
    //   meta: {
    //     title: '游戏订单',
    //     showTitle: true
    //   }
    // },
    // {
    //   name: 'TradeTubi',
    //   path: 'trade-tubi',
    //   component: () => import('@/views/trade/trade-tubi/index.vue'),
    //   meta: {
    //     title: '兔币订单',
    //     showTitle: true
    //   }
    // },
    // {
    //   name: 'TradeExchange',
    //   path: 'trade-exchange',
    //   component: () => import('@/views/trade/trade-exchange/index.vue'),
    //   meta: {
    //     title: '汇率设置',
    //     showTitle: true
    //   }
    // }
  ]
}

export default tradeRouter
